var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AEEF",
    d: "M14.415 2.66a1.472 1.472 0 0 0-2.08-2.08L7.5 5.42 2.66.585a1.472 1.472 0 0 0-2.08 2.08L5.42 7.5.585 12.34a1.472 1.472 0 0 0 2.08 2.08L7.5 9.58l4.84 4.835a1.471 1.471 0 0 0 2.08-2.08L9.58 7.5l4.835-4.84Z"
  })));
};
export default SvgClose;